import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { LoginRequestDto } from "../generated/schema";

export function useLogin() {
	const mutation = $api.useMutation("post", "/auth/login");

	return useMutation({
		mutationFn: async (data: LoginRequestDto) => {
			try {
				const result = await mutation.mutateAsync({
					body: data,
					headers: {
						"x-auth-request": "true",
					},
					credentials: "include",
				});

				return result;
			} catch (error) {
				console.error("Login mutation failed:", error);
				throw error;
			}
		},
	});
}
